/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type PlatformPaginatedProperty =
  typeof PlatformPaginatedProperty[keyof typeof PlatformPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlatformPaginatedProperty = {
  LEGAL_NAME: 'LEGAL_NAME',
  TRADING_NAME: 'TRADING_NAME',
  CONTACT_NAME: 'CONTACT_NAME',
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  END_OF_DAY: 'END_OF_DAY',
  TIME_ZONE_CODE: 'TIME_ZONE_CODE',
  INTEGRATION_TYPE: 'INTEGRATION_TYPE',
  TRANSFER_TYPE: 'TRANSFER_TYPE',
  CUSTOMER_TYPE: 'CUSTOMER_TYPE',
} as const;
